import { config } from "../environment";

export type AuthSession = {
  session: { id: string; userId: string };
  user: { id: string; email: string };
  tenantId: string;
  tenantOrigin: string;
  tenantPublicOrigin: string;
  tenantPublicWildcardDomain: string | null;
  tenantCustomDomains?: string[];
  tenantApiOrigin?: string;
  intercomUserJwt?: string;
  managedAiLifetimeCreditCents: number | null;
  monthlyTinesUnitsLimit?: number;
  managedAiProviderLocked?: boolean;
} | null;

let sessionIntercomUserJwt: string | undefined;
let sessionMonthlyTinesUnitsLimit: number | undefined;
let sessionManagedAiLifetimeCreditCents: number | null = null;
let sessionManagedAiProviderLocked: boolean | undefined;

export function setSession(session: AuthSession) {
  sessionIntercomUserJwt = session?.intercomUserJwt;
  sessionManagedAiLifetimeCreditCents =
    session?.managedAiLifetimeCreditCents ?? null;
  sessionMonthlyTinesUnitsLimit = session?.monthlyTinesUnitsLimit;
  sessionManagedAiProviderLocked = session?.managedAiProviderLocked;
}

export function intercomUserJwt(): string | undefined {
  return sessionIntercomUserJwt;
}

export function managedAiLifetimeCreditCents(): number | null {
  return sessionManagedAiLifetimeCreditCents;
}

export function monthlyTinesUnitsLimit(): number {
  return sessionMonthlyTinesUnitsLimit ?? config.monthlyTinesUnitsLimit;
}

export function managedAiProviderLocked(): boolean {
  return sessionManagedAiProviderLocked ?? config.managedAIProviderDisabled;
}
